<template>
  <div class="split-container">
    <div class="split-container__left">
      <div class="left-side-content">
        <div class="left-side-content__logo">
          <a :href="`/${$route.params.lang || ''}`">
            <img :src="require('@/assets/interview-logo-register-page.png')" alt="interview.co" />
          </a>
        </div>
        <div class="left-side-content__text">
          <h1>
            {{ resource["loginPresentationTitle"] }}
          </h1>
          <h2>
            {{ resource["loginPresentationDesc"] }}
          </h2>
          <div class="d-flex align-items-center mb-2">
            <i class="icon-tick-rounded"/> <p v-html="resource['loginPresentationDescOne']"></p>
          </div>
          <div class="d-flex align-items-center mb-2">
            <i class="icon-tick-rounded" /> <p v-html="resource['loginPresentationDescTwo']"></p>
          </div>
          <div class="d-flex align-items-center mb-2">
            <i class="icon-tick-rounded" /> <p v-html="resource['loginPresentationDescThree']"></p>
          </div>
          <div class="d-flex mb-2">
            <i class="icon-tick-rounded" /> <p v-html="resource['loginPresentationDescFour']"></p>
          </div>
          <div class="d-flex mb-2">
            <i class="icon-tick-rounded" /> <p v-html="resource['loginPresentationDescFive']"></p>
          </div>
          <div class="d-flex mb-2">
            <i class="icon-tick-rounded" /> <p v-html="resource['loginPresentationDescSix']"></p>
          </div>
        </div>
        <div class="left-side-content__carousel">
          <logo-carousel :itemsToShow="5" :itemsToSlide="1" :autoPlay="true" :playSpeed="1000" :initialSlide="0.5" :transition="900" :infiniteScroll="true" :images="images"/>
          <!-- <venue-carousel :images="images" :autoplayInterval="5000" /> -->
        </div>
        <div class="split-container__mobile">
      <logo-carousel :itemsToShow="3.75" :itemsToSlide="1" :autoPlay="true" :playSpeed="1000" :transition="900" :infiniteScroll="true" :images="images" />
      <!-- <venue-carousel :images="images" :autoplayInterval="5000" /> -->
    </div>
      </div>
    </div>
    <div class="split-container__right">
      <div class="right-side-content">
        <frm-login :return-url="returnUrl" />
      </div>
    </div>
  </div>
</template>

<script>
import apiConfigs from '@/services/configs';
import AccountService from '@/services/account';
import { showNotification } from '@/static/helpers';
import LogoCarousel from '../common/LogoCarousel';

export default {
  name: 'Login',

  components: {
    FrmLogin: () => import('../login/frmLogin.vue'),
    LogoCarousel,
    // GoogleAd: () => import('@/components/GoogleAd.vue'),
  },

  data() {
    return {
      cookieInfoStatus: false,
      siriusUrl: apiConfigs.kariyerUrl,
      returnUrl: this.$route.query.returnUrl,
      images: [
        { src: require('../../assets/images/borusan-carousel.png') },
        { src: require('../../assets/images/perfetti-carousel.png') },
        { src: require('../../assets/images/migros-carousel.png') },
        { src: require('../../assets/images/danone-carousel.png') },
        { src: require('../../assets/images/hm-carousel.png') },
        { src: require('../../assets/images/roche-logo.svg') },
        { src: require('../../assets/images/petrol-ofisi-logo.svg') },
        { src: require('../../assets/images/gsk.png') },
        { src: require('../../assets/images/pepsico-logo.svg') },
        { src: require('../../assets/images/mapfre-logo.svg') },
        { src: require('../../assets/images/cigna-logo.svg') },
        { src: require('../../assets/images/socar-logo.svg') },
      ],

      // deferredPrompt: null,
    };
  },

  beforeCreate() {
    // if (process.env.VUE_APP_ENV !== 'development') window.location.reload();
  },

  created() {
    const isOtpRequired = AccountService.checkOtp();
    const isOptionalOtp = AccountService.checkOptionalOtp();
    this.getCookieInfoStatus();
    if (!sessionStorage.getItem('HrVenueLoginErrors')) {
      if (AccountService.checkAuth()) {
        if (isOtpRequired || isOptionalOtp) return;
        if (this.returnUrl) {
          window.location = this.returnUrl;
          return null;
        }

        this.$router.push({ name: 'ActiveJobListView' });
      }
    }
    if (this.$route.query.success) {
      // register form event
      dataLayer.push({
        event: 'ga4_event',
        event_name: 'sign_up',
        event_parameters: {
          method: 'email',
        },
        page_type: 'register',
        site_type: 'interview',
      });
    }
  },

  mounted() {
    // check if server has error when set cookie for redirect
    if (sessionStorage.getItem('HrVenueLoginErrors')) {
      // show error message
      const arrErrors = sessionStorage.getItem('HrVenueLoginErrors').split('|');

      // eslint-disable-next-line func-names
      setTimeout(function () {
        for (let i = 0; i < arrErrors.length; i += 1) {
          if (arrErrors[i]) {
            showNotification(
              this.resource['label.Error'],
              arrErrors[i],
              'error',
            );
          }
        }
      }, 300);

      // remove error item
      sessionStorage.removeItem('HrVenueLoginErrors');
    }
  },

  methods: {
    closeCookieInfo() {
      localStorage.setItem('CookieStatus', true);
      this.getCookieInfoStatus();
    },

    getCookieInfoStatus() {
      this.cookieInfoStatus = !localStorage.getItem('CookieStatus');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/style/starter.scss";

.split-container {
  width: 100%;
  min-height: 100dvh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1 0 0;
  align-self: stretch;
  text-align: left;
  overflow: auto;

  @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
    flex-direction: column-reverse;
  }

  &__left {
    background: #FFF;
    width: 55%;
    align-self: stretch;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 100%;

    @media only screen and (max-width: 1150px) {
      width: 50%;
      min-height: auto;
    }

    @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
      width: 100%;
      min-height: auto;
    }

    &:has(.left-side-content__mobile-carousel) {
      @media only screen and (min-width: map-get($grid-breakpoints, 'lg')) {
        display: none;
      }
    }
  }

  &__right {
    background: $orange-primary;
    display: flex;
    width: 45%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    min-height: 100%;

    @media only screen and (max-width: 1150px) {
      width: 50%;
      min-height: auto;
      background: #FFFFFF;
    }

    @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
      width: 100%;
      min-height: auto;
      flex: 1;
      background: #FFFFFF;
    }
  }

  &__mobile {
    background: #FFF;
    padding: 16px 0;
    width: 100%;

    @media only screen and (min-width: map-get($grid-breakpoints, 'lg')) {
      display: none;
    }
  }

  .left-side-content {
    margin: 0 auto;
    max-width: 488px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
    gap: 48px;
    min-height: 100%;

    @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
      margin: 0px 16px;
      gap:40px;
      width: calc(100% - 32px);
    }

    &__logo {
      img {
        margin-bottom: 16px;
        @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
          width: 208px;
          display: none;
        }
      }
    }

    &__text {
      border-left: 2px solid #666666;
      padding-left: 32px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: start;

      @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
        padding-left: 24px;
      }

      h1 {
        font-family: Roboto !important;
        font-weight: 500;
        font-size: 26px;
        line-height: 32px;
        color: #4C4C4C;
        margin-bottom: 8px;

        @media only screen and (max-width: map-get($grid-breakpoints, 'md')) {
          font-size: 28px;
          line-height: 36px;
        }
      }

      h2 {
        font-family: Roboto !important;
        font-weight: 500;
        font-size: 20px;
        line-height: 24px;
        color: #4C4C4C;
        margin-bottom: 24px;

        @media only screen and (max-width: map-get($grid-breakpoints, 'md')) {
          font-size: 18px;
          line-height: 24px;
        }
      }
      p {
        font-family: Roboto !important;
        font-weight: 400;
        font-size: 16px;
        line-height: 130%;
        color: #4C4C4C;
        margin-bottom: 0px;

        @media only screen and (max-width: map-get($grid-breakpoints, 'md')) {
          font-size: 18px;
          line-height: 24px;
        }

        ::v-deep span {
          font-weight: 500 !important;
        }
      }
      i {
        font-size: 20px;
        margin-right: 4px;
      }
    }

    &__carousel {
      max-width: 488px;
      @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
        display: none;
      }
    }
  }

  .right-side-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-height: 100%;

    .register-text {
      border-bottom-right-radius: 20px;
      border-bottom-left-radius: 20px;
      padding: 0 0 20px;
      text-align: center;
      background: #FFF;
      color: #858585;
      width: 356px;
      position: relative;
      top: -20px;

      @media only screen and (max-width: map-get($grid-breakpoints, 'sm')) {
        width: 95%;
        padding-bottom: 0px;
      }

      p {
        color: #777;
      }

      a {
        color: #FF8D06;
        text-decoration: none;
      }
    }
  }
}
</style>
